/**
 * Search-phrase normalization. Mirrored by `backend/app/Support/SearchPhrase.php`;
 * change both together. Both suites load the same vectors from
 * `backend/tests/Fixtures/search-phrase-vectors.json`.
 *
 * The collapsed set is explicit, so JS and PCRE agree: `\s`, `\p{Z}`, plus U+0085 (NEL),
 * U+180E (Mongolian vowel separator) and U+FEFF (BOM / zero-width no-break space). Only an
 * ASCII space is trimmed at the edges; `String.prototype.trim` is deliberately not used,
 * because its character set is not PHP's. An edge NUL is kept on both sides.
 */

// Built from a string with escaped code points so no irregular whitespace sits in the source.
const COLLAPSIBLE = new RegExp("[\\s\\p{Z}\\u0085\\u180E\\uFEFF]+", "gu");

/** Collapses every run of the set above to one space, then trims ASCII spaces. Case is kept. */
export function normalizeSearchPhrase(input: string): string {
  return input.replace(COLLAPSIBLE, " ").replace(/^ +| +$/g, "");
}

/** The grouping key: the normalized phrase, lower-cased. */
export function searchPhraseKey(input: string): string {
  return normalizeSearchPhrase(input).toLowerCase();
}
